exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".sankey-v2[data-v-b7c1d96e]{border-color:#DADADA;border-width:1px;border-style:solid;display:flex;justify-content:space-between}.sankey-v2 .chart.is-loading[data-v-b7c1d96e]{visibility:hidden}\n", ""]);

